var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('email_verify_page.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('email_verify_page.step_section.steps')
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("email_verify_page.form_title") || _vm.trans('email_verify_title', 'Email 驗證')) + " ")]), _vm.getModuleConfig('email_verify_page.form_desc') ? _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('email_verify_page.form_desc'))
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page__desc__text"
  }, [_vm._v(" " + _vm._s(_vm.trans('email_code_send_to', 'Email 驗證碼已發送至')) + " "), _c('b', {
    staticClass: "google-sans-code"
  }, [_vm._v(_vm._s(_vm.maskedEmail))]), _vm.counter > 0 ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.counterMessage)
    }
  })]) : _c('div', [_vm._v(" " + _vm._s(_vm.trans('expired_email_code', 'Email 驗證碼已過期，請重新取得驗證碼。')) + " ")])]), _c('div', {
    staticClass: "code-input"
  }, [_c('CodeInput', {
    key: _vm.codeInputKey,
    ref: "codeInput",
    staticClass: "google-sans-code",
    class: {
      invalid: !_vm.isValid
    },
    attrs: {
      "loading": false,
      "fields": _vm.verifyCodeLength,
      "fieldHeight": 80
    },
    on: {
      "change": _vm.onChange,
      "complete": _vm.onChange
    }
  }), !_vm.isValid ? _c('div', {
    staticClass: "form__error-msg"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage || _vm.trans('wrong_email_code', '驗證碼有誤，請再次確認')) + " ")]) : _vm._e()], 1), _vm.message ? _c('div', {
    staticClass: "email-validate__message"
  }, [_vm._v(" " + _vm._s(_vm.message) + " ")]) : _vm._e(), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" " + _vm._s(_vm.trans('not_receive', '沒收到嗎？')) + " "), _c('span', {
    on: {
      "click": _vm.handleResend
    }
  }, [_vm._v(" " + _vm._s(_vm.resendText) + " ")])]), _c('div', {
    staticClass: "page__bottom"
  }, [_vm._v(" " + _vm._s(_vm.trans('wrong_email', 'Email 錯誤？')) + " "), _c('span', {
    on: {
      "click": _vm.handleReturn
    }
  }, [_vm._v(_vm._s(_vm.trans('refill_data', '重新填寫資料')))])])]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.submitIsDisabled
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("email_verify_page.button_text") || _vm.trans('submit', '送出')) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }